import Crypto from "crypto-js"
import Cookie from "js-cookie"
import { v4 as uuid } from "uuid"
import { getNewAxiosInstance, responseErrorHandler } from "../../axiosConfig"

const instance = getNewAxiosInstance()
instance.interceptors.response.use((res) => res, responseErrorHandler)

const cookieName = "reservaqui-storage"
let encryptionToken = Cookie.get(cookieName) || uuid()
Cookie.set(cookieName, encryptionToken, {
  secure: process.env.SECURE_COOKIE,
  expires: 1,
})

const storage = {
  getItem: (key) => {
    const store = localStorage.getItem(key)

    if (store) {
      try {
        const bytes = Crypto.AES.decrypt(store, encryptionToken)
        return JSON.parse(bytes.toString(Crypto.enc.Utf8))
      } catch (e) {
        localStorage.clear()
      }
    }

    return null
  },
  setItem: (key, value) => {
    const store = Crypto.AES.encrypt(
      JSON.stringify(value),
      encryptionToken
    ).toString()
    return localStorage.setItem(key, store)
  },
  removeItem: (key) => {
    localStorage.removeItem(key)
  },
  removeAll: () => {
    localStorage.clear()
  },
}
// state
const state = {
  token: storage.getItem("token"),
  token_update_date: new Date(storage.getItem("token_update_date")),
  user: {
    roles: storage.getItem("papeis") ? storage.getItem("papeis") : [],
    username: storage.getItem("username"),
    userId: storage.getItem("userId"),
  },
}

// actions
const actions = {
  login({ commit }, authData) {
    return instance
      .post("auth/local", {
        identifier: authData.email,
        password: authData.password,
      })
      .then((res) => {
        const { jwt } = res.data
        const date = new Date()
        commit("UPDATE_AUTH_DATA", { token: jwt, data: date })
        return instance.get("/users/me", {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
      })
      .then((res) => {
        const date = new Date()
        const { username, role, id } = res.data
        commit("AUTHENTICATE", {
          token: state.token,
          username: username,
          papeis: [role.name],
          date,
          userId: id,
        })
      })
  },

  register(_, { username, email, password }) {
    return instance.post("auth/local/register", {
      username,
      email,
      password,
    })
  },

  recover(_, email) {
    return instance.post("auth/forgot-password", {
      email,
    })
  },

  reset(_, { code, password, passwordConfirmation }) {
    return instance.post("auth/reset-password", {
      code,
      password,
      passwordConfirmation,
    })
  },

  updateToken({ commit }, tokenData) {
    const date = new Date()
    commit("UPDATE_AUTH_DATA", { token: tokenData.token, date })
  },

  removeToken({ commit }) {
    commit("CLEAR_AUTH_DATA")
  },

  updateUsername(context, payload) {
    context.commit("UPDATE_USERNAME", payload.username)
  },
}

// getters
const getters = {
  isAuthenticated(state) {
    return state.token !== null
  },

  token(state) {
    return state.token
  },
  isValidDateToken(state) {
    return new Date() <= new Date(state.token_update_date).addHours(1)
  },
  username(state) {
    return state.user.username
  },
  userId(state) {
    return state.user.userId
  },
  user(state) {
    return state.user
  },
  isAdministrador(state) {
    return state.user.roles.includes("ADMINISTRADOR")
  },
  isPrefeitura(state) {
    return state.user.roles.includes("PREFEITURA")
  },
  isSolicitante(state) {
    return state.user.roles.includes("SOLICITANTE")
  },
  roles(state) {
    return state.user.roles
  },
}

// mutations
const mutations = {
  AUTHENTICATE: (state, authUser) => {
    encryptionToken = uuid()

    state.token = authUser.token
    state.user.roles = authUser.papeis
    state.user.username = authUser.username
    state.token_update_date = authUser.date
    state.user.userId = authUser.userId

    storage.setItem("token", authUser.token)
    storage.setItem("papeis", authUser.papeis)
    storage.setItem("username", authUser.username)
    storage.setItem("token_update_date", authUser.date)
    storage.setItem("userId", authUser.userId)

    Cookie.set(cookieName, encryptionToken, {
      secure: process.env.SECURE_COOKIE,
      expires: new Date(authUser.date).addHours(1),
    })
  },
  CLEAR_AUTH_DATA: (state) => {
    state.token = null
    state.user.roles = []
    state.user.username = null
    state.token_update_date = null
    state.user.userId = null

    storage.removeAll()

    Cookie.remove(cookieName)
  },
  UPDATE_AUTH_DATA: (state, tokenData) => {
    state.token = tokenData.token
    state.token_update_date = tokenData.date

    storage.setItem("token", tokenData.token)
    storage.setItem("token_update_date", tokenData.date)

    Cookie.set(cookieName, encryptionToken, {
      secure: process.env.SECURE_COOKIE,
      expires: new Date(tokenData.date).addHours(1),
    })
  },
  UPDATE_USERNAME: (state, newUsername) => {
    state.user.username = newUsername
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
